export default "__VITE_ASSET__DwSTiWxd__"